import { render, staticRenderFns } from "./SlackMeetingReminder.view.vue?vue&type=template&id=e52299c4&scoped=true&"
import script from "./SlackMeetingReminder.view.vue?vue&type=script&lang=js&"
export * from "./SlackMeetingReminder.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52299c4",
  null
  
)

export default component.exports